module.exports = __webpack_public_path__ + "img/30.b57e1036.jpeg";